import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  Toolbar,
  ToolbarButton,
  mergeClasses,
} from '@fluentui/react-components';
import {
  DeleteRegular,
  ArrowStepOverRegular,
  DismissRegular,
} from '@fluentui/react-icons';

import { useToolbarStyles } from '../styles/toolbar-style';

export const LibraryPageToolbar = ({
  i18n,
  onDelete,
  onMoveTo,
  onClear,
  selectedCount,
}) => {
  const classes = useToolbarStyles();

  return (
    <Toolbar className={classes.toolbar}>
      <div>
        <ToolbarButton
          icon={<DeleteRegular />}
          onClick={onDelete}
          appearance="primary"
          className={mergeClasses('toolbar-delete-button', classes.toolbarButton)}
        >
          {i18n.getString(_TL_('Delete'))}
        </ToolbarButton>
        <ToolbarButton
          icon={<ArrowStepOverRegular />}
          onClick={onMoveTo}
          appearance="primary"
          className={classNames('toolbar-move-button', classes.toolbarButton)}
        >
          {i18n.getString(_TL_('Move to folder'))}
        </ToolbarButton>
      </div>
      <ToolbarButton
        icon={<DismissRegular />}
        onClick={onClear}
        appearance="primary"
        className={classes.toolbarButton}
        aria-label={i18n.getString(_TL_('Clear {{selectedCount}} selected'), { selectedCount })}
      >
        {i18n.getString(_TL_('{{selectedCount}} selected'), { selectedCount })}
      </ToolbarButton>
    </Toolbar>
  );
};

LibraryPageToolbar.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
  onMoveTo: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  selectedCount: PropTypes.number.isRequired,
};
